import type { StaticImageData } from 'next/image'
import Image from 'next/image'

import logoTunasMuda from './images/logo-1.webp'
import logoKidsRepublic from './images/logo-2.webp'
import logoAmrBinDinar from './images/logo-3.webp'
import logoSampoerna from './images/logo-4.webp'
import logoTetumBunaya from './images/logo-7.webp'
import logoKominfo from './images/logo-9.webp'
import logoYpmipa from './images/logo-10.webp'
import logoSmsg from './images/logo-11.webp'
import { Marquee } from './marquee'

interface Logo {
  name: string
  src: StaticImageData | string
}

const cdn = (file: string) => `https://cdn.bacapibo.com/${file}`

/** Schools, publishers and community partners, best-known first (home page). */
export const PARTNER_LOGOS: Logo[] = [
  { name: 'KOMINFO', src: logoKominfo },
  { name: 'Sampoerna Academy', src: logoSampoerna },
  { name: 'Penerbit Kanisius', src: cdn('logo_kanisius-1.webp') },
  { name: 'Global Jaya School', src: cdn('logo_globaljaya.webp') },
  { name: 'Noura', src: cdn('logo_noura.webp') },
  { name: 'Kids Republic Primary School', src: logoKidsRepublic },
  { name: 'Ikatan Guru Indonesia', src: cdn('logo_igi.webp') },
  { name: 'Tetum Bunaya', src: logoTetumBunaya },
  { name: 'Litara', src: cdn('logo_litara.webp') },
  { name: 'Literasi Anak Indonesia', src: cdn('logo_YLAI.webp') },
  { name: 'Tunas Muda School', src: logoTunasMuda },
  { name: 'Guangxi Normal University Press', src: cdn('logo_guangxi-1.webp') },
  { name: 'YPMIPA', src: logoYpmipa },
  { name: 'Semua Murid Semua Guru', src: logoSmsg },
]

/** Schools only (Sekolah page). */
export const SCHOOL_LOGOS: Logo[] = [
  { name: 'Sampoerna Academy', src: logoSampoerna },
  { name: 'Global Jaya School', src: cdn('logo_globaljaya.webp') },
  { name: 'Kids Republic Primary School', src: logoKidsRepublic },
  { name: 'Tunas Muda School', src: logoTunasMuda },
  { name: 'Tetum Bunaya', src: logoTetumBunaya },
  { name: 'Sekolah Islam Tugasku', src: cdn('logo_sekolah-islam-tugasku.webp') },
  { name: 'Amr Bin Dinar', src: logoAmrBinDinar },
  { name: 'PAUD Anak Ceria', src: cdn('logo_paudanakceria-1.webp') },
]

interface LogoStripProps {
  logos: Logo[]
  duration?: number
  setsPerHalf?: number
}

export function LogoStrip({ logos, duration = 60, setsPerHalf = 1 }: LogoStripProps) {
  return (
    <Marquee duration={duration} setsPerHalf={setsPerHalf}>
      {logos.map((logo) => (
        <div
          key={logo.name}
          className='bg-neutral-white border-grey-20 flex h-15 shrink-0 items-center justify-center rounded-xl border p-1.5 md:h-18 md:p-2'
        >
          <Image
            src={logo.src}
            alt={logo.name}
            height={56}
            width={typeof logo.src === 'string' ? 160 : undefined}
            className='h-11.5 w-auto md:h-14'
          />
        </div>
      ))}
    </Marquee>
  )
}
